import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

import { TRoutes } from '../../shared/const'
import PublicFooter from '../../components/PublicFooter'
import logoIcon from '../../assets/icons/logo.svg'
import styles from './style.module.scss'

/*
 * Gemeinsames Layout der oeffentlichen Rechtsseiten (Impressum, Datenschutz,
 * Nutzungsbedingungen, Barrierefreiheit). Die Texte selbst sind bewusst nur
 * auf Deutsch (rechtlich massgebliche Fassung, analog zur Handbuch-Ausnahme);
 * das Seitengeruest (Zurueck-Link, Footer) ist zweisprachig.
 */
function LegalPage({ title, stand, children }) {
	const { t, i18n } = useTranslation()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	return (
		<div className={styles.root}>
			<header className={styles.header}>
				<Link to={TRoutes.MAIN} className={styles.homeLink}>
					<img src={logoIcon} alt="Junior Datenbank" className={styles.logo} />
					<span>Junior Datenbank</span>
				</Link>
				<Link to={TRoutes.MAIN} className={styles.backLink}>
					← {t('Back to home page')}
				</Link>
			</header>

			<main className={styles.content}>
				<h1>{title}</h1>
				{stand && <p className={styles.stand}>Stand: {stand}</p>}
				{i18n.language !== 'ger' && (
					<p className={styles.langNote}>
						These legal documents are provided in German only; the German version is legally binding.
					</p>
				)}
				{children}
			</main>

			<PublicFooter />
		</div>
	)
}

LegalPage.propTypes = {
	title: PropTypes.string.isRequired,
	stand: PropTypes.string,
	children: PropTypes.node.isRequired
}

export default LegalPage
